export default __webpack_public_path__ + "static/Finances-AutoCredit-FinancialLeasing-FinancialRenting-624x176~GlnsuRFP-f7b5cc1c927642b9ed106513742d6ca0.png";